import React from 'react';
import { Box } from '@mui/material';
import { ERROR, TEXT_DARK, TEXT_SECONDARY } from './tokens';

/**
 * A view whose first load failed with nothing the reader can do about it.
 * It stays, and says why the page is empty.
 */
export default function ViewError({ message, entity }) {
  return (
    <Box sx={{
      flex: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '24px',
    }}>
      <Box sx={{ maxWidth: 420, textAlign: 'center' }}>
        <svg
          width="26"
          height="26"
          viewBox="0 0 24 24"
          fill="none"
          stroke={ERROR}
          strokeWidth="2"
          strokeLinecap="round"
        >
          <circle cx="12" cy="12" r="9" />
          <line x1="12" y1="8" x2="12" y2="13" />
          <line x1="12" y1="16.5" x2="12.01" y2="16.5" />
        </svg>
        <Box sx={{
          fontSize: 15, fontWeight: 600, color: TEXT_DARK, margin: '8px 0 4px',
        }}>
          {`Couldn't load ${entity}`}
        </Box>
        <Box sx={{ fontSize: 13, color: TEXT_SECONDARY, lineHeight: 1.5 }}>
          {message || 'Something went wrong.'}
        </Box>
      </Box>
    </Box>
  );
}
